/* eslint-disable @typescript-eslint/no-explicit-any */

import { Type } from '@angular/core';

/**
 * In ivy, resolver._factories no longer return all factories. We cannot find a component factory by its name(string type).
 * This decorator is used to register these components which need to be found by their name.
 *
 * Angular team is considering adding resolver._factories to ivy: https://github.com/angular/angular/issues/33715
 */
export class MetaComponent {
    private static registeredComponents: Map<string, Type<any>> = new Map<string, Type<any>>();

    /**
     * register a component
     */
    public static component(): (target: Type<any>) => void {
        return (target: Type<any>) => {
            MetaComponent.registerComponent(target);
        };
    }

    /**
     * get a component by its name
     * @param name component's className
     */
    public static componentByName(name: string): Type<any> {
        return this.registeredComponents.get(name);
    }

    private static registerComponent(target: Type<any>): void {
        const name = Reflect.get(target, 'className');
        if (!name) {
            throw new Error('Class name is required to register component in MetaComponent');
        }
        if (!this.registeredComponents.has(name)) {
            this.registeredComponents.set(name, target);
        }
    }
}
